<template>
  <div v-if="photos.length" class="trip-gallery">
    <h3 v-if="title">{{ title }}</h3>
    <div class="trip-gallery-grid">
      <button
        v-for="(photo, index) in photos"
        :key="photo.id || index"
        type="button"
        class="trip-gallery-thumb"
        @click="openAt(index)"
      >
        <img :src="photo.thumb_url || photo.url" :alt="photo.filename || 'Фото'" loading="lazy" />
      </button>
    </div>

    <div v-if="lightboxOpen" class="trip-gallery-lightbox" @click.self="close">
      <button type="button" class="trip-gallery-close" aria-label="Закрыть" @click="close">×</button>
      <button
        v-if="photos.length > 1"
        type="button"
        class="trip-gallery-nav trip-gallery-nav--prev"
        aria-label="Предыдущее"
        @click="prev"
      >
        ‹
      </button>
      <img :src="photos[currentIndex].url" :alt="photos[currentIndex].filename || 'Фото'" />
      <button
        v-if="photos.length > 1"
        type="button"
        class="trip-gallery-nav trip-gallery-nav--next"
        aria-label="Следующее"
        @click="next"
      >
        ›
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  photos: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: 'Фотографии',
  },
})

const lightboxOpen = ref(false)
const currentIndex = ref(0)

function openAt(index) {
  currentIndex.value = index
  lightboxOpen.value = true
}

function close() {
  lightboxOpen.value = false
}

function prev() {
  currentIndex.value = (currentIndex.value - 1 + props.photos.length) % props.photos.length
}

function next() {
  currentIndex.value = (currentIndex.value + 1) % props.photos.length
}
</script>

<style scoped>
.trip-gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.5rem;
}

.trip-gallery-thumb {
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 0.375rem;
  overflow: hidden;
}

.trip-gallery-thumb img {
  display: block;
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.trip-gallery-lightbox {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.trip-gallery-lightbox img {
  max-width: min(90vw, 960px);
  max-height: 85vh;
  object-fit: contain;
}

.trip-gallery-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  border: none;
  background: transparent;
  color: #fff;
  font-size: 2rem;
  cursor: pointer;
}

.trip-gallery-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 2rem;
  width: 3rem;
  height: 3rem;
  border-radius: 999px;
  cursor: pointer;
}

.trip-gallery-nav--prev {
  left: 1rem;
}

.trip-gallery-nav--next {
  right: 1rem;
}
</style>
